import { useParams, useLocation, Link } from "react-router-dom";
import { CheckCircle } from "@phosphor-icons/react";
import { formatPrice } from "../lib/api";

export default function OrderSuccessPage() {
  const { number } = useParams();
  const order = useLocation().state?.order;

  return (
    <div className="mx-auto max-w-3xl px-4 py-16 text-center">
      <CheckCircle size={64} weight="fill" className="mx-auto text-[#16A34A]" />
      <h1 data-testid="order-success-title" className="mt-6 font-heading text-3xl md:text-4xl font-bold tracking-tight">Demo pasūtījums saglabāts!</h1>
      <p className="mt-3 text-slate-600">Pasūtījuma numurs: <span data-testid="order-number" className="font-bold text-[#1D1D1F]">{number}</span></p>
      <p className="mt-2 text-sm text-slate-500">Pasūtījums nav nosūtīts un preces nav rezervētas. To var apskatīt tikai šīs pārlūkprogrammas demo vēsturē.</p>

      {order && (
        <div className="mt-8 border border-border text-left">
          <div className="bg-[#1D1D1F] text-white px-4 py-2.5 text-xs font-semibold tracking-wide">Pasūtījuma saturs</div>
          {order.items.map((i) => (
            <div key={i.sku} className="flex justify-between gap-3 px-4 py-3 border-b border-border text-sm">
              <span>{i.qty}× {i.name}</span>
              <span className="font-semibold whitespace-nowrap">{formatPrice(i.total)}</span>
            </div>
          ))}
          <div className="px-4 py-3 text-sm space-y-1">
            <div className="flex justify-between"><span>Bez PVN</span><span>{formatPrice(order.subtotal)}</span></div>
            <div className="flex justify-between"><span>PVN 21%</span><span>{formatPrice(order.vat)}</span></div>
            <div className="flex justify-between font-black font-heading text-base"><span>KOPĀ</span><span>{formatPrice(order.total)}</span></div>
          </div>
        </div>
      )}

      <div className="mt-8 flex justify-center gap-3">
        <Link to="/katalogs" data-testid="success-catalog-link" className="btn-industrial bg-[#2E86D1] px-6 py-3 text-sm font-semibold tracking-wide text-white hover:bg-[#1F6DB2]">Turpināt iepirkties</Link>
        <Link to="/konts" data-testid="success-account-link" className="btn-industrial border border-slate-300 px-6 py-3 text-sm font-semibold tracking-wide hover:bg-[#2E86D1] hover:text-white hover:border-[#2E86D1]">Mans konts</Link>
      </div>
    </div>
  );
}
